export default __webpack_public_path__ + "static/media/6.6df7dde1.webp";